import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the site activity tab component.
 */
const useSiteActivityStyles = makeStyles()(() => ({
  siteActivityContainerRow: {
    display: 'flex',
    flex: '1',
    borderRadius: theme.borderRadius.m,
    boxShadow: theme.containerShadow,
    overflow: 'hidden',
    backgroundColor: theme.background.paper,
  },
  siteActivityContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
}));

export default useSiteActivityStyles;
